document.addEventListener('DOMContentLoaded', function () {
	const hero = document.querySelector('.home-hero__options');
	if (!hero) return;
	const list = hero.querySelector('.home-hero__options__list');
	const choice = hero.querySelector('.home-hero__options__list__choice');
	const dropdown = hero.querySelector('.home-hero__options__list__dropdown');
	const options = dropdown ? dropdown.querySelectorAll('.home-hero__options__list__option') : [];
	const cta = hero.querySelector('.home-hero__options__cta');

	// Open/close dropdown
	choice.addEventListener('click', function (e) {
		e.stopPropagation();
		dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';
		list.classList.toggle('open');
	});

	// Select option
	options.forEach(option => {
		option.addEventListener('click', function (e) {
			e.stopPropagation();
			const label = option.textContent;
			const url = option.getAttribute('data-url');
			choice.textContent = label;
			choice.setAttribute('data-selected-url', url);
			dropdown.style.display = 'none';
			list.classList.remove('open');
		});
	});

	// CTA button click
	cta.addEventListener('click', function () {
		const url = choice.getAttribute('data-selected-url');
		if (url) {
			window.location.href = url;
		}
	});

	// Close dropdown on outside click
	document.addEventListener('click', function (e) {
		if (!list.contains(e.target)) {
			dropdown.style.display = 'none';
			list.classList.remove('open');
		}
	});
});
